import styled from '@emotion/styled';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import tw from 'twin.macro';
import Cross from 'assets/svg/Cross';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
interface Props {
    allCheckedAttribute: any;
    attributeType: any;
    setAllCheckedAttribute: Function;
    onClickOfAttributeCapsule: Function;
    allSelectedValueForAllAttribute: any;
    attributeTypes: any;
    isAttributeDisabled: boolean;
}

function FilterSideShowViewCapsul({
    allCheckedAttribute,
    attributeType,
    setAllCheckedAttribute,
    onClickOfAttributeCapsule,
    allSelectedValueForAllAttribute,
    attributeTypes,
    isAttributeDisabled,
}: Props) {
    const [showMoreLess, setShowMoreLess] = useState(false);
    const [sortedObject, setSortedObject] = useState<any>({});
    const SelectionCapsule = styled.span`
        ${tw` bg-bgBackground p-1.5 rounded text-purpleFont flex w-fit items-center gap-2`}
    `;
    const { appConfig } = useContext(UserContext);
    const globalFilterConfig = getConfig('globalFilter', appConfig);
    //to get all attribute type
    let listOfAttributeType = useMemo(() => {
        let list: any = [];
        for (let dim in attributeTypes) {
            list = [...list, ...attributeTypes?.[dim]];
        }
        return list;
    }, [attributeTypes]);
    //to sort the selection as per the order
    function orderSelection(listOfAttributeType: any, allCheckedAttribute: any, setSortedObject: Function) {
        let sorted: any = {};
        listOfAttributeType.forEach((attrName: string) => {
            if (attrName in allCheckedAttribute) {
                sorted[attrName] = allCheckedAttribute[attrName];
            }
        });
        setSortedObject(() => sorted);
    }
    //to update the check list of all attribute type
    useEffect(() => {
        if (Object.keys(allCheckedAttribute).length) {
            orderSelection(listOfAttributeType, allCheckedAttribute, setSortedObject);
        }
    }, [allCheckedAttribute]);

    return (
        <>
            {Object.keys(sortedObject[attributeType] || {}).length ? (
                <div>
                    <div className="flex flex-wrap gap-2">
                        {Object.keys(allCheckedAttribute[attributeType]).map(
                            (attributeNames: any, indexOfAttributeType: number) => {
                                if (indexOfAttributeType > 2 && !showMoreLess) return null;
                                return (
                                    <SelectionCapsule className="font-xs" key={indexOfAttributeType}>
                                        <span>{attributeNames}</span>
                                        <span
                                            onClick={() => {
                                                if (isAttributeDisabled) return;
                                                onClickOfAttributeCapsule(
                                                    allCheckedAttribute,
                                                    attributeNames,
                                                    attributeType,
                                                    setAllCheckedAttribute,
                                                    allSelectedValueForAllAttribute,
                                                );
                                            }}
                                            className={` ${
                                                isAttributeDisabled ? 'pointer-events-none' : 'cursor-pointer'
                                            } `}
                                        >
                                            <Cross />
                                        </span>
                                    </SelectionCapsule>
                                );
                            },
                        )}
                    </div>
                    <div
                        className="flex justify-end text-xs text-purpleFont font-medium cursor-pointer mt-2"
                        onClick={() => setShowMoreLess(!showMoreLess)}
                    >
                        {Object.keys(allCheckedAttribute[attributeType])?.length > 3 && (
                            <span>{showMoreLess ? 'Show less' : 'Show more'}</span>
                        )}
                    </div>
                </div>
            ) : (
                ''
            )}
        </>
    );
}

export default FilterSideShowViewCapsul;
